






































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { AuthModule } from '@/store/Auth/AuthModule';

@Component({ name: 'WelcomeWidget' })
export default class extends SaascadaVue {

    get me() {
        return AuthModule.me;
    }

    get currentHour() {
        return new Date().getHours();
    }

    get dateToday() {
        const today  = new Date();
        return today.toLocaleDateString("en-GB", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    }

}
